/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import { ALL_FISH_KEYS, FRIENDS_KEY } from './gameData';
import Phaser from 'phaser';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, ALL_FISH_KEYS, AllFishAnimationData.frames);
  fixPivot(mainTex, FRIENDS_KEY, FriendsAnimationData.frames);
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 * @param {string} animationKey 
 */
export function addFishAnimationToSprite(sprite, animationKey, play = true) {
  const animationData = AllFishAnimationData.animations[animationKey];
  if (animationData.frames.length === 1) {
    sprite.stop();

    // this animation only has 1 frame, just set it
    sprite.setFrame(ALL_FISH_KEYS + animationData.frames[0]);
    return;
  }
  if (sprite.anims.exists(animationKey)) {
    if (play) sprite.play(animationKey);
    return;
  }

  const frames = [];
  animationData.frames.forEach(frameNum => frames.push({ frame: ALL_FISH_KEYS + frameNum.toString() }));
  sprite.anims.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: animationData.framerate ?? 24,
      key: animationKey,
      frames
    }
  );
  if (animationData.next !== null && animationData.next !== undefined) {
    if (AllFishAnimationData.animations[animationData.next].frames.length > 1) {
      if (!sprite.anims.exists(animationData.next)) {
        addFishAnimationToSprite(sprite, animationData.next, false);
      }
    }
    sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + animationKey, () => {
      if (AllFishAnimationData.animations[animationData.next].frames.length === 1) {
        // the next "animation" is just a frame, set it
        sprite.setFrame(ALL_FISH_KEYS + AllFishAnimationData.animations[animationData.next].frames[0]);
      }
      else {
        sprite.play(animationData.next);
      }
    });
  }
  if (play) sprite.play(animationKey);
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 * @param {string} animationKey 
 */
export function addFriendAnimationToSprite(sprite, animationKey, play = true) {
  const animationData = FriendsAnimationData.animations[animationKey];
  if (animationData.frames.length === 1) {
    sprite.stop();

    // this animation only has 1 frame, just set it
    sprite.setFrame(FRIENDS_KEY + animationData.frames[0]);
    return;
  }
  if (sprite.anims.exists(animationKey)) {
    if (play) sprite.play(animationKey);
    return;
  }

  const frames = [];
  animationData.frames.forEach(frameNum => frames.push({ frame: FRIENDS_KEY + frameNum.toString() }));
  sprite.anims.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: 24,
      key: animationKey,
      frames
    }
  );
  if (animationData.next !== null && animationData.next !== undefined) {
    if (FriendsAnimationData.animations[animationData.next].frames.length > 1) {
      if (!sprite.anims.exists(animationData.next)) {
        addFriendAnimationToSprite(sprite, animationData.next, false);
      }
    }
    sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + animationKey, () => {
      if (FriendsAnimationData.animations[animationData.next].frames.length === 1) {
        // the next "animation" is just a frame, set it
        sprite.setFrame(FRIENDS_KEY + FriendsAnimationData.animations[animationData.next].frames[0]);
      }
      else {
        sprite.play(animationData.next);
      }
    });
  }
  if (play) sprite.play(animationKey);
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

export function getFishFrameName(key) {
  return ALL_FISH_KEYS + AllFishAnimationData.animations[key].frames[0];
}

export function getFriendFrameName(key) {
  return FRIENDS_KEY + FriendsAnimationData.animations[key].frames[0];
}

// this data comes from the original game; this is the CreateJs sprite sheet animation export
export const AllFishAnimationData = {
  frames: [
    [1121, 123, 24, 44, 0, 0, -5],
    [899, 123, 25, 45, 0, 0, -4],
    [844, 123, 24, 46, 0, -1, -4],
    [816, 123, 24, 46, 0, -1, -4],
    [789, 123, 23, 46, 0, -2, -4],
    [600, 123, 22, 46, 0, -2, -4],
    [419, 123, 23, 47, 0, -2, -3],
    [317, 123, 22, 48, 0, -3, -3],
    [343, 123, 22, 48, 0, -3, -3],
    [266, 123, 21, 48, 0, -4, -3],
    [242, 123, 20, 48, 0, -4, -3],
    [144, 123, 21, 49, 0, -4, -2],
    [193, 123, 20, 49, 0, -5, -2],
    [2, 123, 20, 50, 0, -5, -2],
    [73, 123, 19, 50, 0, -5, -2],
    [96, 123, 19, 50, 0, -6, -2],
    [1959, 2, 19, 51, 0, -6, -1],
    [1937, 2, 18, 51, 0, -7, -1],
    [1830, 2, 18, 52, 0, -7, -1],
    [1809, 2, 17, 52, 0, -7, -1],
    [1894, 2, 17, 52, 0, -8, -1],
    [1641, 2, 17, 53, 0, -8, 0],
    [1621, 2, 16, 53, 0, -9, 0],
    [1543, 2, 16, 54, 0, -9, 0],
    [1563, 2, 15, 54, 0, -9, 0],
    [1724, 2, 17, 52, 0, -8, -1],
    [1703, 2, 17, 52, 0, -7, -1],
    [574, 123, 22, 47, 0, -2, -3],
    [1066, 123, 24, 45, 0, -1, -4],
    [1094, 123, 23, 44, 0, -1, -5],
    [1421, 123, 23, 43, 0, -1, -5],
    [1901, 123, 22, 42, 0, -2, -6],
    [1784, 123, 22, 42, 0, -2, -6],
    [144, 177, 21, 41, 0, -3, -6],
    [194, 177, 21, 40, 0, -3, -7],
    [560, 177, 20, 39, 0, -4, -7],
    [713, 177, 20, 38, 0, -4, -8],
    [761, 177, 20, 38, 0, -5, -8],
    [973, 177, 19, 37, 0, -5, -8],
    [1574, 177, 19, 36, 0, -6, -9],
    [1741, 177, 18, 35, 0, -6, -9],
    [2, 222, 19, 34, 0, -6, -10],
    [25, 222, 18, 34, 0, -7, -10],
    [1426, 177, 19, 36, 0, -6, -9],
    [1338, 177, 20, 36, 0, -5, -9],
    [842, 177, 21, 38, 0, -4, -8],
    [244, 177, 22, 40, 0, -3, -7],
    [219, 177, 21, 40, 0, -3, -7],
    [1842, 123, 23, 42, 0, -2, -6],
    [1970, 123, 24, 42, 0, -1, -6],
    [1366, 123, 24, 44, 0, -1, -5],
    [144, 2, 52, 114, 0, 0, 0],
    [1338, 123, 24, 44, 0, 0, -5],
    [982, 123, 25, 45, 0, 0, -4],
    [761, 123, 24, 46, 0, -1, -4],
    [733, 123, 24, 46, 0, -1, -4],
    [626, 123, 23, 46, 0, -2, -4],
    [680, 123, 22, 46, 0, -2, -4],
    [547, 123, 23, 47, 0, -2, -3],
    [369, 123, 22, 48, 0, -3, -3],
    [291, 123, 22, 48, 0, -3, -3],
    [217, 123, 21, 48, 0, -4, -3],
    [395, 123, 20, 48, 0, -4, -3],
    [119, 123, 21, 49, 0, -4, -2],
    [169, 123, 20, 49, 0, -5, -2],
    [49, 123, 20, 50, 0, -5, -2],
    [26, 123, 19, 50, 0, -5, -2],
    [2005, 2, 19, 50, 0, -6, -2],
    [1982, 2, 19, 51, 0, -6, -1],
    [1915, 2, 18, 51, 0, -7, -1],
    [1787, 2, 18, 52, 0, -7, -1],
    [1873, 2, 17, 52, 0, -7, -1],
    [1852, 2, 17, 52, 0, -8, -1],
    [1682, 2, 17, 53, 0, -8, 0],
    [1662, 2, 16, 53, 0, -9, 0],
    [1601, 2, 16, 54, 0, -9, 0],
    [1582, 2, 15, 54, 0, -9, 0],
    [1745, 2, 17, 52, 0, -8, -1],
    [1766, 2, 17, 52, 0, -7, -1],
    [471, 123, 22, 47, 0, -2, -3],
    [1038, 123, 24, 45, 0, -1, -4],
    [1394, 123, 23, 44, 0, -1, -5],
    [1448, 123, 23, 43, 0, -1, -5],
    [1657, 123, 22, 42, 0, -2, -6],
    [1758, 123, 22, 42, 0, -2, -6],
    [51, 177, 21, 41, 0, -3, -6],
    [365, 177, 21, 40, 0, -3, -7],
    [408, 177, 20, 39, 0, -4, -7],
    [737, 177, 20, 38, 0, -4, -8],
    [930, 177, 20, 38, 0, -5, -8],
    [1115, 177, 19, 37, 0, -5, -8],
    [1403, 177, 19, 36, 0, -6, -9],
    [1719, 177, 18, 35, 0, -6, -9],
    [2022, 177, 19, 34, 0, -6, -10],
    [47, 222, 18, 34, 0, -7, -10],
    [1315, 177, 19, 36, 0, -6, -9],
    [1449, 177, 20, 36, 0, -5, -9],
    [905, 177, 21, 38, 0, -4, -8],
    [270, 177, 22, 40, 0, -3, -7],
    [169, 177, 21, 40, 0, -3, -7],
    [1927, 123, 23, 42, 0, -2, -6],
    [1683, 123, 24, 42, 0, -1, -6],
    [1149, 123, 24, 44, 0, -1, -5],
    [200, 2, 52, 114, 0, 0, 0],
    [1618, 177, 37, 36, 0, 0, -5],
    [1157, 177, 35, 37, 0, -2, -5],
    [468, 177, 33, 39, 0, -4, -4],
    [110, 177, 30, 41, 0, -7, -3],
    [1726, 123, 28, 42, 0, -9, -2],
    [1177, 123, 26, 44, 0, -11, -1],
    [1011, 123, 23, 45, 0, -14, -1],
    [446, 123, 21, 47, 0, -16, 0],
    [706, 123, 23, 46, 0, -14, 0],
    [1207, 123, 25, 44, 0, -12, -1],
    [1490, 123, 26, 43, 0, -11, -2],
    [584, 177, 32, 39, 0, -5, -4],
    [785, 177, 34, 38, 0, -3, -4],
    [1196, 177, 36, 37, 0, -1, -5],
    [1680, 177, 35, 35, 0, -1, -6],
    [1940, 177, 34, 34, 0, -3, -6],
    [499, 222, 32, 33, 0, -4, -7],
    [464, 222, 31, 33, 0, -5, -7],
    [431, 222, 29, 33, 0, -7, -7],
    [130, 260, 28, 32, 0, -8, -7],
    [853, 260, 27, 31, 0, -9, -8],
    [730, 260, 26, 31, 0, -10, -8],
    [932, 260, 25, 30, 0, -11, -8],
    [1137, 260, 24, 29, 0, -12, -9],
    [1188, 260, 22, 29, 0, -14, -9],
    [1862, 177, 36, 35, 0, -1, -6],
    [980, 2, 73, 78, 0, 0, 0],
    [320, 222, 39, 33, 0, 0, 0],
    [612, 222, 38, 33, 0, -1, 0],
    [571, 222, 37, 33, 0, -2, 0],
    [654, 222, 36, 33, 0, -3, 0],
    [1282, 222, 35, 33, 0, -4, 0],
    [1103, 222, 34, 33, 0, -5, 0],
    [694, 222, 33, 33, 0, -6, 0],
    [1421, 222, 32, 33, 0, -7, 0],
    [1457, 222, 31, 33, 0, -8, 0],
    [1525, 222, 30, 33, 0, -9, 0],
    [363, 222, 29, 33, 0, -10, 0],
    [225, 222, 28, 33, 0, -11, 0],
    [67, 260, 36, 32, 0, -3, 0],
    [516, 260, 35, 31, 0, -4, -1],
    [478, 260, 34, 31, 0, -5, -1],
    [385, 260, 33, 31, 0, -6, -1],
    [202, 260, 32, 32, 0, -7, 0],
    [238, 260, 31, 32, 0, -8, 0],
    [1616, 222, 30, 33, 0, -9, 0],
    [257, 222, 29, 33, 0, -10, 0],
    [1650, 222, 28, 33, 0, -11, 0],
    [852, 222, 27, 33, 0, -12, 0],
    [1773, 222, 26, 33, 0, -13, 0],
    [1480, 2, 59, 63, 0, 0, 0],
    [918, 222, 39, 33, 0, 0, 0],
    [961, 222, 38, 33, 0, -1, 0],
    [1843, 222, 37, 33, 0, -2, 0],
    [1803, 222, 36, 33, 0, -3, 0],
    [1026, 222, 35, 33, 0, -4, 0],
    [1065, 222, 34, 33, 0, -5, 0],
    [1141, 222, 33, 33, 0, -6, 0],
    [1210, 222, 32, 33, 0, -7, 0],
    [1884, 222, 31, 33, 0, -8, 0],
    [1355, 222, 30, 33, 0, -9, 0],
    [1919, 222, 29, 33, 0, -10, 0],
    [1389, 222, 28, 33, 0, -11, 0],
    [162, 260, 36, 32, 0, -3, 0],
    [555, 260, 35, 31, 0, -4, -1],
    [594, 260, 34, 31, 0, -5, -1],
    [693, 260, 33, 31, 0, -6, -1],
    [1987, 222, 32, 32, 0, -7, 0],
    [1952, 222, 31, 32, 0, -8, 0],
    [883, 222, 31, 33, 0, -8, 0],
    [1321, 222, 30, 33, 0, -9, 0],
    [1492, 222, 29, 33, 0, -10, 0],
    [1178, 222, 28, 33, 0, -11, 0],
    [754, 222, 27, 33, 0, -12, 0],
    [290, 222, 26, 33, 0, -13, 0],
    [1417, 2, 59, 63, 0, 0, 0],
    [884, 260, 20, 31, 0, 0, -6],
    [329, 260, 20, 32, 0, 0, -6],
    [1682, 222, 19, 33, 0, -1, -5],
    [2000, 177, 18, 34, 0, -2, -5],
    [1978, 177, 18, 34, 0, -2, -5],
    [1763, 177, 17, 35, 0, -3, -4],
    [1533, 177, 17, 36, 0, -3, -4],
    [1513, 177, 16, 36, 0, -4, -4],
    [694, 177, 15, 38, 0, -5, -3],
    [542, 177, 14, 39, 0, -6, -3],
    [348, 177, 13, 40, 0, -7, -2],
    [35, 177, 12, 41, 0, -8, -2],
    [1954, 123, 12, 42, 0, -8, -1],
    [1711, 123, 11, 42, 0, -9, -1],
    [1295, 123, 10, 44, 0, -10, 0],
    [1611, 123, 11, 43, 0, -9, 0],
    [954, 177, 15, 37, 0, -5, -3],
    [1493, 177, 16, 36, 0, -4, -4],
    [1003, 222, 19, 33, 0, -1, -5],
    [306, 260, 19, 32, 0, -1, -6],
    [908, 260, 20, 30, 0, 0, -7],
    [961, 260, 19, 30, 0, -1, -7],
    [1296, 260, 19, 29, 0, -1, -7],
    [1406, 260, 18, 28, 0, -2, -8],
    [1342, 260, 17, 28, 0, -3, -8],
    [1490, 260, 17, 26, 0, -3, -9],
    [1552, 260, 16, 26, 0, -4, -9],
    [1532, 260, 16, 26, 0, -4, -9],
    [1685, 260, 15, 24, 0, -5, -10],
    [1630, 260, 14, 24, 0, -6, -10],
    [1775, 260, 14, 22, 0, -6, -11],
    [1793, 260, 13, 22, 0, -7, -11],
    [1722, 260, 14, 23, 0, -6, -10],
    [1611, 260, 15, 25, 0, -5, -9],
    [1428, 260, 17, 27, 0, -3, -8],
    [1089, 260, 18, 29, 0, -2, -7],
    [894, 2, 82, 80, 0, -1, -1],
    [422, 260, 20, 31, 0, 0, -6],
    [2023, 222, 20, 32, 0, 0, -6],
    [1593, 222, 19, 33, 0, -1, -5],
    [69, 222, 18, 34, 0, -2, -5],
    [203, 222, 18, 34, 0, -2, -5],
    [1659, 177, 17, 35, 0, -3, -4],
    [1597, 177, 17, 36, 0, -3, -4],
    [1554, 177, 16, 36, 0, -4, -4],
    [823, 177, 15, 38, 0, -5, -3],
    [390, 177, 14, 39, 0, -6, -3],
    [331, 177, 13, 40, 0, -7, -2],
    [2032, 123, 12, 41, 0, -8, -2],
    [1641, 123, 12, 42, 0, -8, -1],
    [1626, 123, 11, 42, 0, -9, -1],
    [2028, 2, 10, 44, 0, -10, 0],
    [1475, 123, 11, 43, 0, -9, 0],
    [1138, 177, 15, 37, 0, -5, -3],
    [1473, 177, 16, 36, 0, -4, -4],
    [731, 222, 19, 33, 0, -1, -5],
    [107, 260, 19, 32, 0, -1, -6],
    [984, 260, 20, 30, 0, 0, -7],
    [1066, 260, 19, 30, 0, -1, -7],
    [1165, 260, 19, 29, 0, -1, -7],
    [1384, 260, 18, 28, 0, -2, -8],
    [1363, 260, 17, 28, 0, -3, -8],
    [1511, 260, 17, 26, 0, -3, -9],
    [1572, 260, 16, 26, 0, -4, -9],
    [1470, 260, 16, 26, 0, -4, -9],
    [1666, 260, 15, 24, 0, -5, -10],
    [1648, 260, 14, 24, 0, -6, -10],
    [1757, 260, 14, 22, 0, -6, -11],
    [1740, 260, 13, 22, 0, -7, -11],
    [1704, 260, 14, 23, 0, -6, -10],
    [1592, 260, 15, 25, 0, -5, -9],
    [1449, 260, 17, 27, 0, -3, -8],
    [1319, 260, 19, 28, 0, -2, -8],
    [808, 2, 82, 80, 0, -1, -1],
    [1274, 177, 37, 36, 0, 0, -5],
    [1236, 177, 34, 37, 0, -2, -5],
    [432, 177, 32, 39, 0, -4, -4],
    [296, 177, 31, 40, 0, -6, -3],
    [2, 177, 29, 41, 0, -8, -3],
    [1520, 123, 27, 43, 0, -10, -2],
    [1309, 123, 25, 44, 0, -12, -1],
    [928, 123, 23, 45, 0, -14, -1],
    [522, 123, 21, 47, 0, -16, 0],
    [653, 123, 23, 46, 0, -14, 0],
    [1551, 123, 26, 43, 0, -11, -2],
    [1869, 123, 28, 42, 0, -9, -2],
    [76, 177, 30, 41, 0, -7, -3],
    [656, 177, 34, 38, 0, -3, -4],
    [996, 177, 36, 37, 0, -1, -5],
    [1784, 177, 35, 35, 0, -1, -6],
    [1902, 177, 34, 34, 0, -3, -6],
    [1246, 222, 32, 33, 0, -4, -7],
    [1738, 222, 31, 33, 0, -5, -7],
    [1705, 222, 29, 33, 0, -7, -7],
    [35, 260, 28, 32, 0, -8, -7],
    [822, 260, 27, 31, 0, -9, -8],
    [792, 260, 26, 31, 0, -10, -8],
    [1008, 260, 25, 30, 0, -11, -8],
    [1268, 260, 24, 29, 0, -12, -9],
    [1242, 260, 22, 29, 0, -14, -9],
    [760, 260, 28, 31, 0, -8, -8],
    [273, 260, 29, 32, 0, -7, -7],
    [1559, 222, 30, 33, 0, -6, -7],
    [166, 222, 33, 34, 0, -3, -6],
    [1057, 2, 73, 78, 0, 0, 0],
    [1362, 177, 37, 36, 0, 0, -5],
    [1036, 177, 35, 37, 0, -2, -5],
    [505, 177, 33, 39, 0, -4, -4],
    [1998, 123, 30, 41, 0, -7, -3],
    [1810, 123, 28, 42, 0, -9, -2],
    [1265, 123, 26, 44, 0, -11, -1],
    [955, 123, 23, 45, 0, -14, -1],
    [497, 123, 21, 47, 0, -16, 0],
    [872, 123, 23, 46, 0, -14, 0],
    [1236, 123, 25, 44, 0, -12, -1],
    [1581, 123, 26, 43, 0, -11, -2],
    [620, 177, 32, 39, 0, -5, -4],
    [867, 177, 34, 38, 0, -3, -4],
    [1075, 177, 36, 37, 0, -1, -5],
    [1823, 177, 35, 35, 0, -1, -6],
    [128, 222, 34, 34, 0, -3, -6],
    [535, 222, 32, 33, 0, -4, -7],
    [396, 222, 31, 33, 0, -5, -7],
    [785, 222, 29, 33, 0, -7, -7],
    [353, 260, 28, 32, 0, -8, -7],
    [662, 260, 27, 31, 0, -9, -8],
    [632, 260, 26, 31, 0, -10, -8],
    [1037, 260, 25, 30, 0, -11, -8],
    [1214, 260, 24, 29, 0, -12, -9],
    [1111, 260, 22, 29, 0, -14, -9],
    [446, 260, 28, 31, 0, -8, -8],
    [2, 260, 29, 32, 0, -7, -7],
    [818, 222, 30, 33, 0, -6, -7],
    [91, 222, 33, 34, 0, -3, -6],
    [1134, 2, 73, 78, 0, 0, 0],
    [1830, 260, 16, 16, 0, 0, 0],
    [1850, 260, 16, 13, 0, 0, -1],
    [1890, 260, 16, 8, 0, 0, -4],
    [2042, 2, 0, 0, 0, 0, 0],
    [1910, 260, 16, 2, 0, 0, -7],
    [1870, 260, 16, 10, 0, 0, -3],
    [1810, 260, 16, 16, 0, 0, 0],
    [2, 2, 67, 117, 0, -2, -2],
    [73, 2, 67, 117, 0, -2, -2],
    [466, 2, 110, 81, 0, -2, -2],
    [1314, 2, 99, 67, 0, -2, -2],
    [1211, 2, 99, 67, 0, -2, -2],
    [256, 2, 101, 85, 0, -2, -2],
    [361, 2, 101, 85, 0, -2, -2],
    [580, 2, 110, 81, 0, -2, -2],
    [694, 2, 110, 81, 0, -2, -2]
  ],
  animations: {
    Fish_5_Body: { frames: [179] },
    Fish_Round_Eye_Idle: { frames: [315] },
    Fish_1_Body: { frames: [51] },
    Fish_Round_Eye_Look: {
      next: 'Fish_Round_Eye_Idle',
      frames: [
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        321,
        321,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315,
        315
      ]
    },
    Fish_4_Body: { frames: [154] },
    Fish_2_Body_Outline: { frames: [323] },
    Fish_9_Tail_Idle: { frames: [285] },
    Fish_2_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_2_Tail_Swim2',
      frames: [
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        74,
        77,
        72,
        78,
        68,
        67,
        65,
        63,
        61,
        60,
        79,
        56,
        55,
        80,
        52
      ]
    },
    Fish_3_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_3_Tail_Swim1',
      frames: [
        104,
        118,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        127,
        126,
        125,
        124,
        123,
        122,
        121,
        120,
        119,
        118,
        129,
        104
      ]
    },
    Fish_7_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_7_Tail_Swim2',
      frames: [
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        225,
        226,
        227,
        227,
        228,
        229,
        230,
        231,
        231,
        232,
        230,
        228,
        227,
        226,
        225,
        233,
        234,
        222,
        221,
        235,
        236
      ]
    },
    Fish_9_Body_Outline: { frames: [330] },
    Fish_3_Tail_Idle: { frames: [104] },
    Fish_6_Tail_Idle: { frames: [180] },
    Fish_2_Tail_Idle: { frames: [52] },
    Fish_3_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_3_Tail_Swim2',
      frames: [
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        108,
        107,
        115,
        116,
        117
      ]
    },
    Fish_7_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_7_Tail_Swim1',
      frames: [
        217,
        237,
        238,
        239,
        240,
        240,
        241,
        242,
        243,
        244,
        245,
        245,
        246,
        247,
        248,
        249,
        246,
        245,
        250,
        244,
        243,
        251,
        240,
        252,
        239,
        238,
        237
      ]
    },
    Fish_1_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_1_Tail_Swim1',
      frames: [
        0,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        41,
        43,
        44,
        37,
        45,
        46,
        47,
        48,
        49,
        50,
        0
      ]
    },
    Fish_2_Body: { frames: [103] },
    Fish_8_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_8_Tail_Swim1',
      frames: [
        268,
        254,
        269,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        278,
        277,
        276,
        275,
        280,
        281,
        282,
        272,
        271,
        283,
        269,
        269,
        254
      ]
    },
    Fish_3_Body: { frames: [130] },
    Fish_8_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_8_Tail_Swim2',
      frames: [
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        260,
        264,
        265,
        266,
        256,
        267
      ]
    },
    Fish_4_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_4_Tail_Swim1',
      frames: [
        131,
        131,
        132,
        132,
        132,
        133,
        133,
        134,
        143,
        144,
        144,
        145,
        145,
        146,
        146,
        147,
        147,
        148,
        148,
        148,
        149,
        149,
        150,
        150,
        151,
        151,
        152,
        152,
        153,
        153,
        152,
        152,
        151,
        151,
        150,
        150,
        149,
        149,
        148,
        148,
        148,
        147,
        147,
        146,
        146,
        145,
        145,
        144,
        144,
        143,
        134,
        133,
        133,
        132,
        132,
        132,
        131,
        131
      ]
    },
    Fish_3_Body_Outline: { frames: [324] },
    Fish_4_Body_Outline: { frames: [325] },
    Fish_4_Tail_Idle: { frames: [131] },
    Fish_5_Body_Outline: { frames: [326] },
    Fish_4_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_4_Tail_Swim2',
      frames: [
        131,
        131,
        132,
        132,
        133,
        133,
        133,
        134,
        134,
        135,
        135,
        135,
        136,
        136,
        137,
        137,
        137,
        138,
        138,
        138,
        139,
        139,
        140,
        140,
        140,
        141,
        141,
        142,
        141,
        141,
        140,
        140,
        140,
        139,
        139,
        139,
        138,
        138,
        137,
        137,
        137,
        136,
        136,
        136,
        135,
        135,
        134,
        134,
        134,
        133,
        133,
        133,
        132,
        132,
        131,
        131,
        131
      ]
    },
    Fish_1_Body_Outline: { frames: [322] },
    Fish_1_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_1_Tail_Swim2',
      frames: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        22,
        25,
        20,
        26,
        16,
        15,
        13,
        11,
        9,
        8,
        27,
        4,
        3,
        28,
        0
      ]
    },
    Fish_1_Tail_Idle: { frames: [0] },
    Fish_9_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_9_Tail_Swim2',
      frames: [
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        289,
        288,
        296,
        297,
        298
      ]
    },
    Fish_7_Body_Outline: { frames: [328] },
    Fish_9_Body: { frames: [314] },
    Fish_6_Body_Outline: { frames: [327] },
    Fish_9_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_9_Tail_Swim1',
      frames: [
        285,
        299,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        308,
        307,
        306,
        305,
        310,
        311,
        312,
        302,
        301,
        313,
        299,
        299,
        285
      ]
    },
    Fish_8_Body_Outline: { frames: [329] },
    Fish_7_Tail_Idle: { frames: [217] },
    Fish_5_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_5_Tail_Swim1',
      frames: [
        155,
        155,
        156,
        156,
        157,
        158,
        167,
        168,
        168,
        169,
        170,
        170,
        171,
        171,
        172,
        173,
        174,
        175,
        175,
        176,
        176,
        177,
        178,
        178,
        177,
        176,
        176,
        175,
        175,
        174,
        173,
        172,
        171,
        171,
        170,
        170,
        169,
        168,
        168,
        167,
        158,
        157,
        156,
        156,
        155,
        155
      ]
    },
    Fish_6_Body: { frames: [216] },
    Fish_6_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_6_Tail_Swim1',
      frames: [
        180,
        200,
        201,
        202,
        203,
        203,
        204,
        205,
        206,
        207,
        208,
        208,
        209,
        210,
        211,
        210,
        212,
        209,
        208,
        208,
        213,
        207,
        206,
        205,
        214,
        204,
        203,
        203,
        215,
        201,
        201,
        200,
        180
      ]
    },
    Fish_8_Body: { frames: [284] },
    Fish_5_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_5_Tail_Swim2',
      frames: [
        155,
        156,
        156,
        156,
        157,
        157,
        158,
        158,
        159,
        159,
        159,
        160,
        160,
        161,
        161,
        162,
        162,
        163,
        163,
        163,
        164,
        164,
        165,
        165,
        166,
        166,
        165,
        165,
        164,
        164,
        163,
        163,
        162,
        162,
        161,
        161,
        160,
        160,
        159,
        159,
        158,
        158,
        157,
        157,
        156,
        156,
        155,
        155
      ]
    },
    Fish_Round_Eye_Blink: {
      next: 'Fish_Round_Eye_Idle',
      frames: [316, 317, 317, 318, 318, 319, 317, 320, 316]
    },
    Fish_6_Tail_Swim1: {
      framerate: 16,
      next: 'Fish_6_Tail_Swim2',
      frames: [
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        188,
        189,
        190,
        190,
        191,
        192,
        193,
        194,
        194,
        195,
        193,
        191,
        190,
        189,
        188,
        196,
        197,
        185,
        184,
        198,
        199
      ]
    },
    Fish_2_Tail_Swim2: {
      framerate: 16,
      next: 'Fish_2_Tail_Swim1',
      frames: [
        52,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        93,
        95,
        96,
        89,
        97,
        98,
        99,
        100,
        101,
        102,
        52
      ]
    },
    Fish_5_Tail_Idle: { frames: [155] },
    Fish_7_Body: { frames: [253] },
    Fish_8_Tail_Idle: { frames: [254] }
  }
};

export const FriendsAnimationData = {
  frames: [
    [1758, 2, 146, 149, 0, 0, 0],
    [2, 164, 146, 149, 0, 0, 0],
    [118, 313, 54, 36, 1, 0, 0],
    [60, 313, 54, 36, 1, 0, 0],
    [1850, 236, 54, 36, 1, 0, 0],
    [1792, 236, 54, 36, 1, 0, 0],
    [1966, 236, 54, 36, 1, 0, 0],
    [2, 313, 54, 36, 1, 0, 0],
    [1908, 236, 54, 36, 1, 0, 0],
    [176, 313, 54, 36, 1, 0, 0],
    [234, 313, 54, 36, 1, 0, 0],
    [2001, 787, 39, 18, 0, 0, 0],
    [1620, 353, 39, 15, 1, 0, -3],
    [1577, 353, 39, 15, 1, 0, -3],
    [1839, 353, 40, 12, 1, 0, -3],
    [456, 372, 40, 5, 1, 0, -7],
    [544, 372, 40, 5, 1, 0, -7],
    [500, 372, 40, 5, 1, 0, -7],
    [412, 372, 40, 5, 1, 0, -7],
    [148, 372, 39, 11, 1, 0, -3],
    [105, 372, 39, 11, 1, 0, -3],
    [62, 372, 39, 11, 1, 0, -3],
    [2003, 317, 39, 18, 0, 0, 0],
    [1566, 317, 141, 94, 0, -7, 0],
    [1711, 317, 141, 94, 0, -7, 0],
    [1276, 317, 141, 94, 0, -7, 0],
    [447, 428, 143, 93, 0, -6, -1],
    [151, 428, 143, 93, 0, -6, -1],
    [2, 428, 145, 93, 0, -5, -1],
    [1497, 428, 146, 92, 0, -5, -2],
    [741, 428, 147, 92, 0, -5, -2],
    [892, 428, 148, 92, 0, -4, -2],
    [2, 525, 149, 91, 0, -4, -3],
    [155, 525, 150, 91, 0, -3, -3],
    [464, 525, 151, 90, 0, -3, -4],
    [619, 525, 152, 90, 0, -3, -4],
    [1088, 525, 153, 89, 0, -2, -5],
    [1245, 525, 154, 89, 0, -2, -5],
    [931, 525, 153, 89, 0, -2, -5],
    [775, 525, 152, 90, 0, -3, -4],
    [309, 525, 151, 90, 0, -3, -4],
    [1800, 428, 150, 91, 0, -3, -3],
    [1647, 428, 149, 91, 0, -4, -3],
    [1345, 428, 148, 92, 0, -4, -2],
    [1194, 428, 147, 92, 0, -5, -2],
    [1044, 428, 146, 92, 0, -5, -2],
    [298, 428, 145, 93, 0, -5, -1],
    [594, 428, 143, 93, 0, -6, -1],
    [1856, 317, 143, 93, 0, -6, -1],
    [1421, 317, 141, 94, 0, -7, 0],
    [1131, 317, 141, 94, 0, -7, 0],
    [2003, 353, 11, 11, 1, 0, 0],
    [1943, 353, 11, 11, 1, 0, 0],
    [1958, 353, 11, 11, 1, 0, 0],
    [2030, 620, 11, 11, 0, 0, 0],
    [1928, 353, 11, 11, 1, 0, 0],
    [2024, 236, 11, 11, 1, 0, 0],
    [2024, 869, 11, 11, 0, 0, 0],
    [2034, 164, 11, 11, 0, 0, 0],
    [2034, 428, 11, 11, 0, 0, 0],
    [2015, 620, 11, 11, 0, 0, 0],
    [2011, 525, 11, 11, 0, 0, 0],
    [2026, 525, 11, 11, 0, 0, 0],
    [1973, 353, 11, 11, 1, 0, 0],
    [1988, 353, 11, 11, 1, 0, 0],
    [2018, 353, 11, 11, 1, 0, 0],
    [2030, 2, 11, 11, 1, 0, 0],
    [2034, 159, 11, 11, 1, 0, 0],
    [47, 372, 11, 11, 1, 0, 0],
    [1883, 353, 11, 11, 1, 0, 0],
    [1898, 353, 11, 11, 1, 0, 0],
    [1913, 353, 11, 11, 1, 0, 0],
    [355, 869, 172, 77, 0, -1, -2],
    [178, 869, 173, 77, 0, 0, -2],
    [707, 869, 173, 76, 0, 0, -2],
    [1590, 869, 173, 76, 0, 0, -2],
    [1413, 869, 173, 76, 0, 0, -2],
    [1767, 869, 173, 76, 0, 0, -2],
    [356, 2, 173, 75, 1, 0, -2],
    [710, 2, 173, 75, 1, 0, -2],
    [1064, 2, 173, 74, 1, 0, -2],
    [887, 2, 173, 74, 1, 0, -2],
    [1418, 2, 173, 74, 1, 0, -2],
    [1772, 2, 173, 74, 1, 0, -2],
    [1438, 236, 173, 73, 1, 0, -2],
    [1261, 236, 173, 73, 1, 0, -2],
    [1615, 236, 173, 72, 1, 0, -2],
    [1084, 236, 173, 73, 1, 0, -2],
    [907, 236, 173, 73, 1, 0, -2],
    [730, 236, 173, 73, 1, 0, -2],
    [2, 81, 173, 74, 1, 0, -2],
    [179, 81, 173, 74, 1, 0, -2],
    [1241, 2, 173, 74, 1, 0, -2],
    [1595, 2, 173, 74, 1, 0, -2],
    [179, 2, 173, 75, 1, 0, -2],
    [2, 2, 173, 75, 1, 0, -2],
    [533, 2, 173, 75, 1, 0, -2],
    [1060, 869, 173, 76, 0, 0, -2],
    [884, 869, 172, 76, 0, -1, -2],
    [1237, 869, 172, 76, 0, -1, -2],
    [1473, 787, 172, 77, 0, -1, -2],
    [177, 704, 172, 79, 0, -1, 0],
    [1825, 787, 172, 77, 0, -1, -2],
    [531, 869, 172, 77, 0, -1, -2],
    [1055, 704, 172, 78, 0, -1, -2],
    [879, 704, 172, 78, 0, -1, -2],
    [703, 704, 172, 78, 0, -1, -2],
    [1357, 704, 172, 78, 0, -1, -2],
    [353, 704, 171, 79, 0, -2, -2],
    [528, 704, 171, 79, 0, -2, -2],
    [2, 704, 171, 79, 0, -2, -2],
    [1760, 620, 171, 79, 0, -2, -2],
    [705, 620, 171, 80, 0, -2, -2],
    [178, 620, 171, 80, 0, -2, -2],
    [1403, 525, 171, 81, 0, -2, -2],
    [1578, 525, 172, 81, 0, -1, -2],
    [529, 620, 172, 80, 0, -1, -2],
    [2, 620, 172, 80, 0, -1, -2],
    [1754, 525, 172, 80, 0, -1, -2],
    [353, 620, 172, 80, 0, -1, -2],
    [1408, 620, 172, 79, 0, -1, -2],
    [1056, 620, 172, 79, 0, -1, -2],
    [1584, 620, 172, 79, 0, -1, -2],
    [1232, 620, 172, 79, 0, -1, -2],
    [880, 620, 172, 79, 0, -1, -2],
    [131, 787, 172, 78, 0, -1, -2],
    [1789, 704, 172, 78, 0, -1, -2],
    [307, 787, 172, 78, 0, -1, -2],
    [483, 787, 172, 78, 0, -1, -2],
    [1649, 787, 172, 77, 0, -1, -2],
    [2, 869, 172, 77, 0, -1, -2],
    [1297, 787, 172, 77, 0, -1, -2],
    [918, 787, 122, 78, 0, -4, -1],
    [1044, 787, 122, 78, 0, -4, -1],
    [1170, 787, 123, 78, 0, -3, -1],
    [659, 787, 124, 78, 0, -3, -1],
    [1660, 704, 125, 78, 0, -2, -1],
    [787, 787, 127, 78, 0, -1, -1],
    [2, 787, 125, 78, 0, -2, -1],
    [1533, 704, 123, 78, 0, -3, -1],
    [1231, 704, 122, 78, 0, -4, -1],
    [1217, 353, 41, 15, 1, 0, 0],
    [1751, 353, 41, 13, 1, 0, -1],
    [191, 372, 41, 9, 1, 0, -3],
    [281, 372, 41, 8, 1, 0, -3],
    [2046, 2, 0, 0, 0, 0, 0],
    [2046, 317, 0, 0, 0, 0, 0],
    [588, 372, 41, 4, 1, 0, -5],
    [236, 372, 41, 8, 1, 0, -3],
    [2, 372, 41, 11, 1, 0, -2],
    [1706, 353, 41, 13, 1, 0, -1],
    [1172, 353, 41, 15, 1, 0, 0],
    [1127, 353, 41, 15, 1, 0, 0],
    [1082, 353, 41, 15, 1, 0, 0],
    [1037, 353, 41, 15, 1, 0, 0],
    [992, 353, 41, 15, 1, 0, 0],
    [947, 353, 41, 15, 1, 0, 0],
    [902, 353, 41, 15, 1, 0, 0],
    [47, 353, 41, 15, 1, 0, 0],
    [2, 353, 41, 15, 1, 0, 0],
    [2002, 313, 41, 15, 1, 0, 0],
    [1957, 313, 41, 15, 1, 0, 0],
    [1912, 313, 41, 15, 1, 0, 0],
    [1867, 313, 41, 15, 1, 0, 0],
    [1417, 313, 41, 15, 1, 0, 0],
    [1777, 313, 41, 15, 1, 0, 0],
    [292, 313, 41, 15, 1, 0, 0],
    [382, 313, 41, 15, 1, 0, 0],
    [337, 313, 41, 15, 1, 0, 0],
    [562, 313, 41, 15, 1, 0, 0],
    [427, 313, 41, 15, 1, 0, 0],
    [472, 313, 41, 15, 1, 0, 0],
    [1352, 353, 41, 15, 1, 0, 0],
    [1442, 353, 41, 15, 1, 0, 0],
    [1397, 353, 41, 15, 1, 0, 0],
    [517, 313, 41, 15, 1, 0, 0],
    [877, 313, 41, 15, 1, 0, 0],
    [607, 313, 41, 15, 1, 0, 0],
    [652, 313, 41, 15, 1, 0, 0],
    [697, 313, 41, 15, 1, 0, 0],
    [742, 313, 41, 15, 1, 0, 0],
    [1532, 353, 41, 15, 1, 0, 0],
    [787, 313, 41, 15, 1, 0, 0],
    [832, 313, 41, 15, 1, 0, 0],
    [1552, 313, 41, 15, 1, 0, 0],
    [922, 313, 41, 15, 1, 0, 0],
    [967, 313, 41, 15, 1, 0, 0],
    [1012, 313, 41, 15, 1, 0, 0],
    [1057, 313, 41, 15, 1, 0, 0],
    [1102, 313, 41, 15, 1, 0, 0],
    [1147, 313, 41, 15, 1, 0, 0],
    [1192, 313, 41, 15, 1, 0, 0],
    [1237, 313, 41, 15, 1, 0, 0],
    [1282, 313, 41, 15, 1, 0, 0],
    [1327, 313, 41, 15, 1, 0, 0],
    [1372, 313, 41, 15, 1, 0, 0],
    [1307, 353, 41, 15, 1, 0, 0],
    [1462, 313, 41, 15, 1, 0, 0],
    [1507, 313, 41, 15, 1, 0, 0],
    [857, 353, 41, 15, 1, 0, 0],
    [1597, 313, 41, 15, 1, 0, 0],
    [1642, 313, 41, 15, 1, 0, 0],
    [1687, 313, 41, 15, 1, 0, 0],
    [1732, 313, 41, 15, 1, 0, 0],
    [1262, 353, 41, 15, 1, 0, 0],
    [1822, 313, 41, 15, 1, 0, 0],
    [92, 353, 41, 15, 1, 0, 0],
    [1487, 353, 41, 15, 1, 0, 0],
    [137, 353, 41, 15, 1, 0, 0],
    [182, 353, 41, 15, 1, 0, 0],
    [227, 353, 41, 15, 1, 0, 0],
    [272, 353, 41, 15, 1, 0, 0],
    [317, 353, 41, 15, 1, 0, 0],
    [362, 353, 41, 15, 1, 0, 0],
    [407, 353, 41, 15, 1, 0, 0],
    [452, 353, 41, 15, 1, 0, 0],
    [497, 353, 41, 15, 1, 0, 0],
    [542, 353, 41, 15, 1, 0, 0],
    [587, 353, 41, 15, 1, 0, 0],
    [632, 353, 41, 15, 1, 0, 0],
    [677, 353, 41, 15, 1, 0, 0],
    [722, 353, 41, 15, 1, 0, 0],
    [767, 353, 41, 15, 1, 0, 0],
    [812, 353, 41, 15, 1, 0, 0],
    [329, 164, 116, 109, 0, 0, 0],
    [209, 164, 116, 109, 0, 0, 0],
    [1663, 353, 39, 14, 1, 0, 0],
    [1796, 353, 39, 12, 1, 0, -1],
    [369, 372, 39, 8, 1, 0, -3],
    [326, 372, 39, 8, 1, 0, -3],
    [2039, 236, 5, 5, 1, 0, 0],
    [2041, 525, 5, 5, 0, 0, 0],
    [642, 372, 5, 3, 1, 0, -1],
    [651, 372, 5, 1, 1, 0, -2],
    [633, 372, 5, 3, 1, 0, -1],
    [2039, 869, 5, 5, 0, 0, 0],
    [2033, 353, 5, 5, 1, 0, 0],
    [1908, 2, 53, 113, 0, 0, 0],
    [152, 164, 53, 113, 0, 0, 0],
    [296, 2, 47, 158, 0, 0, 0],
    [347, 2, 46, 158, 0, 0, 0],
    [397, 2, 45, 158, 0, 0, 0],
    [446, 2, 42, 158, 0, -1, 0],
    [492, 2, 41, 158, 0, -1, 0],
    [537, 2, 40, 158, 0, -1, 0],
    [581, 2, 41, 158, 0, -1, 0],
    [626, 2, 41, 158, 0, -2, 0],
    [671, 2, 42, 158, 0, -2, 0],
    [717, 2, 44, 158, 0, -2, 0],
    [765, 2, 45, 158, 0, -2, 0],
    [814, 2, 46, 158, 0, -3, 0],
    [864, 2, 48, 158, 0, -3, 0],
    [916, 2, 47, 158, 0, -3, 0],
    [967, 2, 46, 158, 0, -3, 0],
    [46, 2, 46, 158, 0, -2, 0],
    [96, 2, 45, 158, 0, -2, 0],
    [1114, 2, 44, 158, 0, -2, 0],
    [1162, 2, 44, 158, 0, -2, 0],
    [1210, 2, 43, 158, 0, -2, 0],
    [1257, 2, 42, 158, 0, -2, 0],
    [1303, 2, 41, 158, 0, -2, 0],
    [1348, 2, 41, 158, 0, -2, 0],
    [1393, 2, 40, 158, 0, -2, 0],
    [1437, 2, 41, 158, 0, -1, 0],
    [1482, 2, 41, 158, 0, -1, 0],
    [1527, 2, 40, 158, 0, -1, 0],
    [2, 2, 40, 158, 0, -1, 0],
    [1621, 2, 41, 158, 0, -1, 0],
    [1666, 2, 42, 158, 0, -1, 0],
    [1712, 2, 42, 158, 0, -1, 0],
    [1017, 2, 44, 158, 0, 0, 0],
    [1065, 2, 45, 158, 0, 0, 0],
    [247, 2, 45, 158, 0, 0, 0],
    [1571, 2, 46, 158, 0, 0, 0],
    [196, 2, 47, 158, 0, 0, 0],
    [145, 2, 47, 158, 0, 0, 0],
    [449, 164, 108, 107, 0, 0, 0],
    [561, 164, 108, 107, 0, 0, 0],
    [673, 164, 108, 107, 0, 0, 0],
    [785, 164, 108, 107, 0, 0, 0],
    [897, 164, 109, 107, 0, 0, 0],
    [1010, 164, 109, 107, 0, 0, 0],
    [1123, 164, 109, 107, 0, 0, 0],
    [1236, 164, 110, 107, 0, 0, 0],
    [1350, 164, 110, 107, 0, 0, 0],
    [1464, 164, 110, 107, 0, 0, 0],
    [1578, 164, 110, 107, 0, 0, 0],
    [1692, 164, 110, 107, 0, 0, 0],
    [1806, 164, 110, 107, 0, 0, 0],
    [1920, 164, 110, 107, 0, 0, 0],
    [2, 317, 110, 107, 0, 0, 0],
    [116, 317, 110, 107, 0, 0, 0],
    [230, 317, 109, 107, 0, 0, 0],
    [343, 317, 109, 107, 0, 0, 0],
    [456, 317, 109, 107, 0, 0, 0],
    [1018, 317, 109, 107, 0, 0, 0],
    [905, 317, 109, 107, 0, 0, 0],
    [793, 317, 108, 107, 0, 0, 0],
    [681, 317, 108, 107, 0, 0, 0],
    [569, 317, 108, 107, 0, 0, 0],
    [164, 159, 77, 73, 1, -1, 0],
    [244, 236, 77, 73, 1, -1, 0],
    [164, 236, 76, 73, 1, -2, 0],
    [83, 236, 77, 73, 1, -2, 0],
    [1930, 525, 77, 73, 0, -2, 0],
    [649, 236, 77, 73, 1, -2, 0],
    [487, 236, 77, 73, 1, -2, 0],
    [406, 236, 77, 73, 1, -2, 0],
    [325, 236, 77, 73, 1, -2, 0],
    [2, 236, 77, 73, 1, -2, 0],
    [1952, 159, 78, 73, 1, -2, 0],
    [1870, 159, 78, 73, 1, -2, 0],
    [1788, 159, 78, 73, 1, -2, 0],
    [1706, 159, 78, 73, 1, -2, 0],
    [1625, 159, 77, 73, 1, -3, 0],
    [1544, 159, 77, 73, 1, -3, 0],
    [1463, 159, 77, 73, 1, -3, 0],
    [1381, 159, 78, 73, 1, -2, 0],
    [1299, 159, 78, 73, 1, -2, 0],
    [1217, 159, 78, 73, 1, -2, 0],
    [1135, 159, 78, 73, 1, -2, 0],
    [1053, 159, 78, 73, 1, -2, 0],
    [972, 159, 77, 73, 1, -2, 0],
    [891, 159, 77, 73, 1, -2, 0],
    [810, 159, 77, 73, 1, -2, 0],
    [729, 159, 77, 73, 1, -2, 0],
    [648, 159, 77, 73, 1, -2, 0],
    [567, 159, 77, 73, 1, -2, 0],
    [486, 159, 77, 73, 1, -2, 0],
    [405, 159, 77, 73, 1, -2, 0],
    [325, 159, 76, 73, 1, -2, 0],
    [245, 159, 76, 73, 1, -2, 0],
    [83, 159, 77, 73, 1, -1, 0],
    [2, 159, 77, 73, 1, -1, 0],
    [1961, 81, 77, 73, 1, -1, 0],
    [1880, 81, 77, 73, 1, -1, 0],
    [1800, 81, 76, 73, 1, -1, 0],
    [1720, 81, 76, 73, 1, -1, 0],
    [1640, 81, 76, 73, 1, -1, 0],
    [1479, 81, 76, 73, 1, -1, 0],
    [568, 236, 77, 73, 1, 0, 0],
    [1317, 81, 77, 73, 1, 0, 0],
    [1237, 81, 76, 73, 1, 0, 0],
    [1157, 81, 76, 73, 1, 0, 0],
    [1077, 81, 76, 73, 1, 0, 0],
    [997, 81, 76, 73, 1, 0, 0],
    [917, 81, 76, 73, 1, 0, 0],
    [837, 81, 76, 73, 1, 0, 0],
    [757, 81, 76, 73, 1, 0, 0],
    [677, 81, 76, 73, 1, 0, 0],
    [597, 81, 76, 73, 1, 0, 0],
    [517, 81, 76, 73, 1, 0, 0],
    [436, 81, 77, 73, 1, 0, 0],
    [1965, 2, 77, 73, 0, 0, 0],
    [1954, 428, 76, 73, 0, -1, 0],
    [356, 81, 76, 73, 1, -1, 0],
    [1935, 620, 76, 73, 0, -1, 0],
    [1965, 704, 76, 73, 0, -1, 0],
    [1944, 869, 76, 73, 0, -1, 0],
    [1949, 2, 77, 73, 1, -1, 0],
    [1398, 81, 77, 73, 1, -1, 0],
    [1559, 81, 77, 73, 1, -1, 0]
  ],
  animations: {
    Friend_5_Body_Swim: { frames: [224] },
    Friend_1_Body_Swim: { next: 'Friend_1_Body_Idle', frames: [1] },
    Friend_3_Body_Swim: {
      frames: [
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131
      ]
    },
    Friend_4_Eyes_Idle: { frames: [141] },
    Friend_6_Eyes_Idle: { frames: [230] },
    Friend_6_Body_Idle: { frames: [237] },
    Friend_3_Body_Idle: { frames: [72] },
    Friend_5_Body_Idle: { frames: [224] },
    Friend_2_Body_Swim: {
      frames: [
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50
      ]
    },
    Plant_3: {
      next: 'Plant_3',
      frames: [
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361
      ]
    },
    Friend_6_Eyes_Blink: {
      next: 'Friend_6_Eyes_Idle',
      frames: [231, 232, 233, 234, 235, 236]
    },
    Friend_1_Eyes_Blink: {
      next: 'Friend_1_Eyes_Idle',
      frames: [2, 3, 4, 5, 6, 7, 8, 9]
    },
    Friend_4_Body_Swim: {
      speed: 0.25,
      frames: [133, 134, 135, 136, 137, 138, 139, 140]
    },
    Friend_5_Eyes_Idle: { frames: [226] },
    Friend_1_Eyes_Idle: { frames: [10] },
    Friend_2_Eyes_Blink: {
      next: 'Friend_2_Eyes_Idle',
      frames: [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
    },
    Friend_6_Body_Swim: { frames: [238] },
    Plant_2: {
      next: 'Plant_2',
      frames: [
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299
      ]
    },
    Friend_3_Eyes_Blink: {
      next: 'Friend_3_Eyes_Idle',
      frames: [
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70
      ]
    },
    Friend_2_Eyes_Idle: { frames: [11] },
    Plant_1: {
      next: 'Plant_1',
      frames: [
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275
      ]
    },
    Friend_3_Eyes_Idle: { frames: [71] },
    Friend_5_Eyes_Blink: {
      next: 'Friend_5_Eyes_Idle',
      frames: [227, 228, 229]
    },
    Friend_2_Body_Idle: { frames: [23] },
    Friend_4_Eyes_Blink: {
      next: 'Friend_4_Eyes_Idle',
      frames: [
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223
      ]
    },
    Friend_4_Body_Idle: { frames: [132] },
    Friend_1_Body_Idle: { frames: [0] }
  }
};